import config from './nyConfig'
import ApiJsonLogin from "./ApiJson/ApiJsonLogin"
import ApiInformation from "@/api/ApiJson/ApiInformation";
import ApiPublic from "@/api/ApiJson/ApiPublic";
import ApiDic from "@/api/ApiJson/ApiDic";
import ApiWikipedia from "@/api/ApiJson/ApiWikipedia";
import ApiManager from "@/api/ApiJson/ApiManager";
import ApiLand from "@/api/ApiJson/ApiLand";
import ApiCourtship from "@/api/ApiJson/ApiCourtship";
import ApiDemand from "@/api/ApiJson/ApiDemand";
import ApiHomestay from "@/api/ApiJson/ApiHomestay";
import ApiOrder from "@/api/ApiJson/ApiOrder";

const api: { [key: string]: config } = {
    ...ApiJsonLogin,
    ...ApiInformation,
    ...ApiPublic,
    ...ApiDic,
    ...ApiWikipedia,
    ...ApiManager,
    ...ApiLand,
    ...ApiCourtship,
    ...ApiDemand,
    ...ApiHomestay,
    ...ApiOrder
}

export default api